import { render, staticRenderFns } from "./LearningCenterPreset.vue?vue&type=template&id=5e472d58&"
import script from "./LearningCenterPreset.vue?vue&type=script&lang=js&"
export * from "./LearningCenterPreset.vue?vue&type=script&lang=js&"
import style0 from "./LearningCenterPreset.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports